/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

// IMPORTANT: Replace with your actual Google Client ID from the Google Cloud Console.
// You can create one here: https://console.cloud.google.com/apis/credentials
// The Google Drive feature will not work until this placeholder is replaced.
export const VITE_GOOGLE_CLIENT_ID = '111946058403-tmrmhk60dshjjtrra941qijp04ua84ra.apps.googleusercontent.com';

// MCP Server Configuration
// Option 1: Use service binding (recommended for unified auth)
export const MCP_SERVER_URL = '/api/mcp';

// Option 2: Direct MCP worker URL (for direct access or testing)
export const MCP_WORKER_URL = 'https://emsipiga.fidelion.co';

// MCP endpoints for different use cases
export const MCP_ENDPOINTS = {
  // Service binding endpoint (unified auth, recommended)
  SERVICE_BINDING: '/api/mcp',
  
  // Direct worker endpoints
  WORKER_MCP: 'https://emsipiga.fidelion.co/mcp',
  WORKER_OAUTH: 'https://emsipiga.fidelion.co/oauth',
  WORKER_STATUS: 'https://emsipiga.fidelion.co/mcp/status',
} as const;

// Default configuration for the app
export const MCP_CONFIG = {
  // Use service binding by default (unified auth)
  DEFAULT_ENDPOINT: MCP_ENDPOINTS.SERVICE_BINDING,
  
  // Fallback to direct worker if service binding fails
  FALLBACK_ENDPOINT: MCP_ENDPOINTS.WORKER_MCP,
  
  // Request timeout in milliseconds
  TIMEOUT: 10000,
  
  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
} as const;

// IMPORTANT: Replace with your MCP (Model-Centric Platform) server URL.
// This server is expected to handle function calls from the Gemini model.
// export const MCP_SERVER_URL = 'YOUR_MCP_SERVER_URL_HERE';